import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, QrCode } from "lucide-react";
import { fetchExtracts } from "../lib/api";
import { StoryCard } from "./StoryCard";

export const HomeStories = () => {
  const [stories, setStories] = useState([]);
  useEffect(() => { fetchExtracts({ featured: true }).then(setStories).catch(() => setStories([])); }, []);
  if (!stories.length) return null;

  return (
    <section data-testid="home-stories-section" className="py-20 md:py-28 px-6 md:px-12 lg:px-24 bg-[#F4F1EA]">
      <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6">
        <div className="max-w-2xl">
          <p className="flex items-center gap-2 text-xs tracking-[0.3em] uppercase text-[#9E4735] font-body mb-4"><QrCode size={14} /> Distributeur d'extraits littéraires CLED</p>
          <h2 className="font-serif text-4xl md:text-5xl font-light text-[#1A1A1A] leading-tight mb-4">Histoires offertes</h2>
          <p className="font-body text-[#4A4A4A]">Une pause lecture de quelques minutes, à lire ou à écouter sur votre téléphone. Gratuit, sans application.</p>
        </div>
        <Link to="/histoires" data-testid="view-all-stories-link" className="inline-flex items-center gap-2 text-[#2C402E] font-body link-underline">
          Toutes les histoires <ArrowRight size={16} />
        </Link>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
        {stories.slice(0, 3).map((s, i) => <StoryCard key={s.id} story={s} index={i} />)}
      </div>
    </section>
  );
};
